import React from "react";
import { ArrowDownward } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import DataTable from "react-data-table-component";

const sortIcon = <ArrowDownward />;
const selectProps = { indeterminate: (isIndeterminate) => isIndeterminate };

function DataTableBase({ subHeaderComponent, ...props }) {
  return (
    <DataTable
      pagination
      selectableRowsComponent={Checkbox}
      selectableRowsComponentProps={selectProps}
      sortIcon={sortIcon}
      dense
      subHeader={!!subHeaderComponent}
      subHeaderComponent={subHeaderComponent}
      {...props}
    />
  );
}

export default DataTableBase;
